const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';

function initBrandNav() {
    const menuToggle = document.querySelector('[data-nav-menu-toggle]');
    const menu = document.querySelector('[data-nav-menu]');
    const backdrop = document.querySelector('[data-nav-backdrop]');
    const menuClose = document.querySelector('[data-nav-menu-close]');
    const mobileProductsDetails = document.querySelector('details[data-mobile-nav-products]');
    const header = document.querySelector('.marketing-nav');

    const syncAnchorOffset = () => {
        if (!header) {
            return;
        }

        const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
        const offsetAdjustment = isDesktop ? 14 : 8;
        const offset = Math.max(header.offsetHeight - offsetAdjustment, 0);

        document.documentElement.style.setProperty('--brand-anchor-offset', `${offset}px`);
    };

    syncAnchorOffset();
    window.addEventListener('resize', syncAnchorOffset);

    const closeMobileNavDrawer = () => {
        if (!menuToggle || !menu || !backdrop) {
            return;
        }

        menu.classList.remove('is-open');
        backdrop.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        menu.setAttribute('aria-hidden', 'true');
        backdrop.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';

        if (mobileProductsDetails) {
            mobileProductsDetails.removeAttribute('open');
        }
    };

    const openMobileNavDrawer = () => {
        if (!menuToggle || !menu || !backdrop) {
            return;
        }

        menu.classList.add('is-open');
        backdrop.classList.add('is-open');
        menuToggle.setAttribute('aria-expanded', 'true');
        menu.setAttribute('aria-hidden', 'false');
        backdrop.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    };

    if (menuToggle && menu && backdrop) {
        menuToggle.addEventListener('click', () => {
            const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
            if (expanded) {
                closeMobileNavDrawer();
            } else {
                openMobileNavDrawer();
            }
        });

        menuClose?.addEventListener('click', (event) => {
            event.stopPropagation();
            closeMobileNavDrawer();
        });

        backdrop.addEventListener('click', closeMobileNavDrawer);

        menu.querySelectorAll('a[href], button[type="submit"]').forEach((item) => {
            item.addEventListener('click', () => {
                closeMobileNavDrawer();
            });
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && menu.classList.contains('is-open')) {
                closeMobileNavDrawer();
            }
        });

        window.addEventListener('resize', () => {
            if (window.matchMedia('(min-width: 1024px)').matches) {
                closeMobileNavDrawer();
            }
        });
    }

    const productsRoot = document.querySelector('[data-nav-products-root]');
    const productsTrigger = document.querySelector('[data-nav-products-trigger]');
    const productsPanel = document.querySelector('[data-nav-products-panel]');

    if (productsRoot && productsTrigger && productsPanel) {
        const setProductsMenuState = (isOpen) => {
            productsTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            productsPanel.classList.toggle('nav-products-dropdown--open', isOpen);
        };

        const closeProductsMenu = () => {
            setProductsMenuState(false);
        };

        const openProductsMenu = () => {
            setProductsMenuState(true);
        };

        productsTrigger.addEventListener('click', (event) => {
            event.preventDefault();
            const expanded = productsTrigger.getAttribute('aria-expanded') === 'true';
            setProductsMenuState(!expanded);
        });

        document.addEventListener('click', (event) => {
            const target = event.target;

            if (!(target instanceof Node)) {
                return;
            }

            if (!productsRoot.contains(target)) {
                closeProductsMenu();
            }
        });

        productsPanel.querySelectorAll('a[href]').forEach((link) => {
            link.addEventListener('click', () => {
                closeProductsMenu();
            });
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closeProductsMenu();
            }
        });

        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            productsRoot.addEventListener('mouseenter', openProductsMenu);
            productsRoot.addEventListener('mouseleave', closeProductsMenu);
        }
    }
}

function initSmoothAnchorScroll() {
    document.querySelectorAll('a[href*="#"]').forEach((anchor) => {
        anchor.addEventListener('click', (event) => {
            const raw = anchor.getAttribute('href');
            if (!raw || raw === '#') {
                return;
            }

            let hash = '';
            try {
                const url = new URL(raw, window.location.href);
                if (url.pathname !== window.location.pathname) {
                    return;
                }
                hash = url.hash;
            } catch (error) {
                return;
            }

            if (!hash) {
                return;
            }

            const targetElement = document.querySelector(hash);
            if (!targetElement) {
                return;
            }

            event.preventDefault();
            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        });
    });
}

function initHeroParallax() {
    const heroParallax = document.querySelector('[data-hero-parallax]');

    if (!heroParallax) {
        return;
    }

    const handleHeroParallax = () => {
        const scrollY = window.scrollY || 0;
        const translateY = -Math.min(scrollY * 0.08, 22);
        const scale = Math.min(1 + scrollY * 0.00006, 1.03);

        heroParallax.style.transform = `translate3d(0, ${translateY}px, 0) scale(${scale})`;
    };

    handleHeroParallax();
    window.addEventListener('scroll', handleHeroParallax, { passive: true });
}

function initBrandPropertyGalleries() {
    document.querySelectorAll('.room-gallery').forEach((gallery) => {
        const imagesContainer = gallery.querySelector('.gallery-images');
        const images = imagesContainer?.querySelectorAll('img') ?? [];
        const prevButton = gallery.querySelector('.gallery-prev');
        const nextButton = gallery.querySelector('.gallery-next');

        if (!imagesContainer || images.length <= 1 || !prevButton || !nextButton) {
            prevButton?.setAttribute('hidden', 'hidden');
            nextButton?.setAttribute('hidden', 'hidden');
            return;
        }

        let currentIndex = Number.parseInt(imagesContainer.dataset.currentIndex ?? '0', 10) || 0;

        const render = () => {
            imagesContainer.style.transform = `translateX(-${currentIndex * 100}%)`;
        };

        prevButton.addEventListener('click', () => {
            currentIndex = (currentIndex - 1 + images.length) % images.length;
            imagesContainer.dataset.currentIndex = String(currentIndex);
            render();
        });

        nextButton.addEventListener('click', () => {
            currentIndex = (currentIndex + 1) % images.length;
            imagesContainer.dataset.currentIndex = String(currentIndex);
            render();
        });

        render();
    });
}

async function submitBrandContactForm(form) {
    const submitButton = form.querySelector('button[type="submit"]');
    const submitText = form.querySelector('#buttonText, #newHomeSubmitText');
    const spinner = form.querySelector('#spinner, #newHomeSpinner');

    submitButton?.setAttribute('disabled', 'disabled');
    if (submitText) {
        submitText.textContent = 'Sending...';
    }
    spinner?.classList.remove('hidden');

    const formData = Object.fromEntries(new FormData(form).entries());
    const recaptchaAction = form.dataset.recaptchaAction ?? 'brand_contact_form';

    try {
        const token = await window.getRecaptchaToken?.(recaptchaAction);

        if (!token) {
            throw new Error('reCAPTCHA could not be completed. Please refresh the page and try again.');
        }

        formData.recaptcha_token = token;
        formData['g-recaptcha-response'] = token;

        const response = await fetch(form.getAttribute('action') ?? window.location.href, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken(),
                Accept: 'application/json',
            },
            body: JSON.stringify(formData),
        });

        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
            throw new Error(data.message || 'Unable to submit the form right now.');
        }

        form.reset();
        window.Swal?.fire({
            title: form.dataset.successTitle || 'Request sent',
            text: form.dataset.successMessage || 'Our team will get back to you soon.',
            icon: 'success',
            confirmButtonColor: '#34d399',
        });
    } catch (error) {
        window.Swal?.fire({
            title: form.dataset.errorTitle || 'Error!',
            text: error instanceof Error ? error.message : 'Please try again.',
            icon: 'error',
            confirmButtonColor: '#34d399',
        });
    } finally {
        submitButton?.removeAttribute('disabled');
        if (submitText) {
            submitText.textContent = form.dataset.submitLabel || submitText.dataset.defaultLabel || 'Send Message';
        }
        spinner?.classList.add('hidden');
    }
}

function initBrandContactForms() {
    document.querySelectorAll('[data-brand-contact-form]').forEach((form) => {
        const submitText = form.querySelector('#buttonText, #newHomeSubmitText');
        if (submitText) {
            submitText.dataset.defaultLabel = submitText.textContent ?? '';
        }

        form.addEventListener('submit', async (event) => {
            event.preventDefault();
            await submitBrandContactForm(form);
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initBrandNav();
    initSmoothAnchorScroll();
    initHeroParallax();
    initBrandPropertyGalleries();
    initBrandContactForms();
});
